import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Text, Button } from 'roo-ui/components';
import ErrorHeading from 'pages/Checkout/BookingErrorDialogs/ErrorHeading';
import { ContactLinks, CallCenterHours } from 'pages/Checkout/BookingErrorDialogs/textSnippets';

const transportError = {
  dialogHeader: 'Sorry, something went wrong.',
  dialogText: (
    <Fragment>
      <Text as="p">We&apos;re having trouble loading the checkout.</Text>
      <Text as="p">To continue with your booking, please refresh the page.</Text>
      <Text as="p">
        If you need further assistance, <ContactLinks />. <CallCenterHours />.
      </Text>
    </Fragment>
  ),
  buttonText: 'Refresh Page',
  strategy: () => window.location.reload(),
};

const badDataError = {
  dialogHeader: "Sorry, we couldn't make your booking at this time",
  dialogText: 'Your selection is no longer available. Please choose a different offer',
  buttonText: 'Back to previous page',
  strategy: () => window.history.back(),
};

const QuoteErrorDialog = ({ error }) => {
  const errorData = error.httpStatus < 500 ? badDataError : transportError;

  const handleOnClick = useCallback(() => {
    errorData.strategy();
  }, [errorData]);

  return (
    <Wrapper>
      <ErrorHeading>{errorData.dialogHeader}</ErrorHeading>
      <Text display="block" mb={6}>
        {errorData.dialogText}
      </Text>
      <Button variant="primary" width={['100%', 'auto']} onClick={handleOnClick}>
        {errorData.buttonText}
      </Button>
    </Wrapper>
  );
};

QuoteErrorDialog.propTypes = {
  error: PropTypes.object,
};

QuoteErrorDialog.defaultProps = {
  error: {},
};

export default QuoteErrorDialog;
